import { render, staticRenderFns } from "./AtomFormInputCheckbox.vue?vue&type=template&id=1af48817&scoped=true&"
import script from "./AtomFormInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./AtomFormInputCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AtomFormInputCheckbox.vue?vue&type=style&index=0&id=1af48817&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af48817",
  null
  
)

export default component.exports